<template>
  <LoadingContainer
    :is-loaded="isLoaded"
    :total="studentsLength"
    kind="Students"
    size="2rem"
  >
    <fieldset class="student-picker" slot="default">
      <legend class="student-picker__legend form__label">Student</legend>
      <template v-for="s in students">
        <input
          type="checkbox"
          :key="`input-${s.id}`"
          :id="s.id"
          :value="s.id"
          name="student-picker"
          class="student-picker__input"
          v-model="checkedStudents"
          @change="$emit('input', checkedStudents)"
        />
        <label
          :key="`label-${s.id}`"
          :for="s.id"
          class="student-picker__label"
        >
          {{ s.name }}
        </label>
      </template>
    </fieldset>

    <router-link
      slot="button"
      class="button button--border button--small"
      :to="{
        name: 'settings-students',
        query: {
          add: true
        }
      }"
      replace
    >
      Add Student
    </router-link>
  </LoadingContainer>
</template>

<script>
import store from '@/store'
import { mapGetters } from 'vuex'

export default {
  name: 'StudentPicker',

  props: {
    value: {
      type: Array,
      default: () => []
    }
  },

  data () {
    return {
      checkedStudents: []
    }
  },

  computed: {
    ...mapGetters({
      students: 'students/sortedStudents',
      studentsLength: 'students/studentsLength',
      isLoaded: 'students/isLoaded'
    })
  },

  mounted () {
    this.checkedStudents = this.value

    store.dispatch('students/getStudents')
  }
}
</script>

<style lang="scss">
.student-picker {
  margin: 1rem 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  gap: .25rem .125rem;
  border: 0;
}

.student-picker__legend {
  display: flex;
  flex: 1 0 100%;
}

.student-picker__input {
  position: absolute;
  opacity: 0;
  z-index: -1;
}

.student-picker__label {
  margin: 0 0.125rem 0.125rem 0;
  padding: .125rem 1rem;
  width: auto;
  height: 2rem;
  display: inline-flex;
  align-items: center;
  border-radius: 2rem;
  font-size: .8rem;
  text-align: center;
  text-transform: uppercase;
  letter-spacing: (1rem / 32);
  color: var(--color-page-fg);
  background-color: var(--color, #CFD8DC);
  border: .125rem solid #FFF;

  &:hover,
  &:active {
    border-color: #78909C;
  }

  :focus + & {
    outline: none;
    box-shadow:
      0 0 0 .125rem var(--color-page-bg),
      0 0 0 .25rem #78909C;
  }

  :checked + & {
    border-color: currentColor;
  }
}
</style>
